import { useQuery } from '@tanstack/react-query'
import { encodeQueryParams, useAxios } from 'packages/core'
import { usePageContext } from 'pageContext'
import useApiWithPagination from './useApiWithPagination'

export const APPLICATION_SETTINGS_KEY = 'APPLICATION_SETTINGS'
export const ALL_APPLICATIONS_KEY = 'ALL_APPLICATIONS'

export const useApplicationSettings = (settingsOverride) => {
    const callApi = useAxios()
    return useQuery(
        [APPLICATION_SETTINGS_KEY],
        () =>
            callApi({
                method: 'GET',
                url: settingsOverride
                    ? `/api/application/settings?settingsOverride=${settingsOverride}`
                    : '/api/application/settings',
            }).then((data) => data.data),
        {
            staleTime: Infinity,
        },
    )
}

export const useAllApplications = () => {
    const callApi = useAxios()
    return useQuery(
        [ALL_APPLICATIONS_KEY],
        () =>
            callApi({
                method: 'GET',
                url: '/api/access/applications',
            }).then((data) => data.data),
        {
            staleTime: Infinity,
        },
    )
}
export const useMyIdConfigSetting = (name) => {
    const callApi = useAxios()
    return useQuery(
        [APPLICATION_SETTINGS_KEY, name],
        () =>
            callApi({
                method: 'GET',
                url: '/api/application/myIdConfigSetting?name=' + name,
            }).then((data) => data.data),
        {
            staleTime: Infinity,
        },
    )
}

export const useMyIdConfigSettings = (names) => {
    const callApi = useAxios()
    const queryParams = names.map((name) => `name=${name}`).join('&')
    return useQuery(
        [APPLICATION_SETTINGS_KEY, names],
        () =>
            callApi({
                method: 'GET',
                url: `/api/application/myIdConfigSettings?${queryParams}`,
            }).then((data) => data.data),
        {
            staleTime: Infinity,
        },
    )
}
